"use strict";

var _interopRequireWildcard = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextArea = void 0;
var _defineProperty2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _textAreaModule = _interopRequireDefault(require("./text-area.module.scss"));
var _autosize = _interopRequireDefault(require("autosize"));
var _noop = require("../../utils/noop");
var isNewRef = function isNewRef(ref) {
  return typeof ref !== 'function';
};
var TextArea = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var id = _ref.id,
    className = _ref.className,
    name = _ref.name,
    value = _ref.value,
    onChange = _ref.onChange,
    _ref$onFocus = _ref.onFocus,
    onFocus = _ref$onFocus === void 0 ? _noop.noop : _ref$onFocus,
    _ref$onKeyDown = _ref.onKeyDown,
    onKeyDown = _ref$onKeyDown === void 0 ? _noop.noop : _ref$onKeyDown,
    placeholder = _ref.placeholder,
    maxLength = _ref.maxLength,
    _ref$autoFocus = _ref.autoFocus,
    autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$error = _ref.error,
    error = _ref$error === void 0 ? false : _ref$error,
    _ref$autoSize = _ref.autoSize,
    autoSize = _ref$autoSize === void 0 ? false : _ref$autoSize,
    containerClassName = _ref.containerClassName;
  (0, _react.useLayoutEffect)(function () {
    if (autoSize) {
      if (!ref) {
        throw new Error('Ref is required to use autosize');
      }
      if (!isNewRef(ref)) {
        throw new Error('The autoSize prop is not supported in the old ref API. Please use the new ref API.');
      } else {
        (0, _autosize.default)(ref.current);
      }
    }
  }, [autoSize, ref]);
  (0, _react.useLayoutEffect)(function () {
    if (autoSize) {
      _autosize.default.update();
    }
  }, [value, autoSize]);
  var getCharacterCount = function getCharacterCount() {
    if (value) {
      return "".concat(value.length, " / ").concat(maxLength);
    } else {
      return "0 / ".concat(maxLength);
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_textAreaModule.default['text-area'], containerClassName)
  }, /*#__PURE__*/_react.default.createElement("textarea", {
    className: (0, _classnames.default)(_textAreaModule.default['text-area__text'], className, (0, _defineProperty2.default)({}, _textAreaModule.default['text-area__text--error'], error)),
    ref: ref,
    id: id,
    "data-testid": id,
    value: value,
    name: name,
    onChange: onChange,
    onFocus: onFocus,
    onKeyDown: onKeyDown,
    placeholder: placeholder,
    maxLength: maxLength,
    autoFocus: autoFocus,
    disabled: disabled
  }), maxLength && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_textAreaModule.default['text-area__instruction'])
  }, getCharacterCount()));
});
exports.TextArea = TextArea;
TextArea.displayName = 'TextArea';